// useSortableTable.js
import {useCallback, useMemo, useState} from 'react';

export const useSortableTable = () => {
  const [sorted, setSorted] = useState([]);

  const handleSort = useCallback((column, sortFn = null) => {
    if (typeof sortFn !== 'function') {
      return;
    }

    setSorted((prevSorted) => {
      const index = prevSorted.findIndex(item => item.column === column);

      if (index === -1) {
        // Добавляем новую сортировку
        return [...prevSorted, {
          column,
          direction: 'ascending',
          sort: sortFn
        }];
      }

      const newSorted = [...prevSorted];
      const currentItem = newSorted[index];

      if (currentItem.direction === 'ascending') {
        // Меняем на убывающую
        newSorted[index] = {
          ...currentItem,
          direction: 'descending'
        };
        return newSorted;
      } else {
        // Убираем сортировку
        newSorted.splice(index, 1);
        return newSorted;
      }
    });
  }, []);

  const sortItems = useCallback((items) => {
    if (!items?.length || !sorted.length) {
      return items || [];
    }

    return [...items].sort((a, b) => {
      for (const sortConfig of sorted) {
        if (typeof sortConfig.sort === 'function') {
          const result = sortConfig.sort(a, b);
          if (result !== 0) {
            return sortConfig.direction === 'descending' ? -result : result;
          }
        }
      }
      return 0;
    });
  }, [sorted]);

  const getWidth = useCallback((item) => item?.width, []);

  // Мемоизируем возвращаемое значение для предотвращения лишних ре-рендеров
  return useMemo(() => ({
    sorted,
    handleSort,
    sortItems,
    getWidth
  }), [sorted, handleSort, sortItems, getWidth]);
};